const itemTypes = {
	itemTypes: 'Item types',
	itemType: 'Item type',
	text: 'Text',
	literature: 'Literature',
};

export default itemTypes;
